import { replaceIcons } from '../../app/legacy/modules/icons';

replaceIcons();
